<div class="c__warranty-group-wrapper">
  @for (warranty of warranties; track warranty) {
    <sd-warranty-checkbox
      (warrantyClicked)="onWarrantyClicked(warranty)"
      [warranty]="warranty"
      [showAll]="showAll"
    />
  }
</div>
<button type="button" class="c__toggle is-link" (click)="showAllWarranty()">
  <span class="is-caption is-bold">{{ !showAll ? showMore : showLess }}</span>
  <sd-icon [name]="showAll ? 'icon-arrow-up' : 'icon-arrow-down'" [size]="iconSizeEnum.xs" />
</button>
